import AuthorizationService from "../../../../services/AuthorizationService";
import { HttpMethod } from "../../../../services/HttpService";
import { generateUrl } from "../../../../apis/VoiceGainAuthSvcApi";

export type GrafanaDataType = {
  orgName?: string;
  orgId?: number;
};

export async function getGrafanaData(
  accountId: string
): Promise<GrafanaDataType | undefined> {
  const url = generateUrl(`/account/${accountId}/grafana`);
  const requestInfo: RequestInfo = url.toString();
  const method = HttpMethod.Get;
  const requestInit: RequestInit = {
    method,
  };
  try {
    const response = await AuthorizationService.authorizedFetch(
      requestInfo,
      requestInit
    );

    let data: GrafanaDataType = await response.json();
    return data;
  } catch (err) {
    console.log(err);
    if (err instanceof Error) {
      throw new Error(`Error fetching grafana data: ${err.message}`);
    }
    throw new Error("Error fetching grafana data");
  }
}

export async function createGrafanaToken(accountId: string) {
  const url = generateUrl(`/account/${accountId}/grafana`);
  const requestInfo: RequestInfo = url.toString();
  const method = HttpMethod.Post;
  const requestInit: RequestInit = {
    method,
  };
  try {
    const response = await AuthorizationService.authorizedFetch(
      requestInfo,
      requestInit
    );
    let data: GrafanaDataType = await response.json();
    return data;
  } catch (err) {
    console.log(err);
    if (err instanceof Error) {
      throw new Error(err.message);
    }
    throw new Error("Error creating grafana token");
  }
}

export async function deleteGrafanaToken(accountId: string) {
  const url = generateUrl(`/account/${accountId}/grafana`);
  const requestInfo: RequestInfo = url.toString();
  const method = HttpMethod.Delete;
  const requestInit: RequestInit = {
    method,
  };
  try {
    const response = await AuthorizationService.authorizedFetch(
      requestInfo,
      requestInit
    );
    if (!response.ok) {
      throw new Error("Error deleting grafana token");
    }
    return true;
  } catch (err) {
    console.log(err);
    if (err instanceof Error) {
      throw new Error(err.message);
    }
    throw new Error("Error deleting grafana token");
  }
}
